const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "Oct 2016 – Jul 2021",
    title: "Lebanese International University",
    desc: "Bachelor of Engineering; Major in Computer and Communications.",
    rate: "GPA: 3.4 ",
  },
  {
    id: 2,
    category: "education",
    year: "Jun 2021",
    title: "CCNA ",
    desc: "Cisco Certified Network Associate (CCNA): 1, 2, and 3",
    rate: "85/100",
  },
  {
    id: 3,
    category: "education",
    year: "Feb 2021 ",
    title: "Cyber Security ",
    desc: "Microsoft Imagine Academy: Security Fundamentals.",
    rate: "  ",
  },
  {
    id: 4,
    category: "experience",
    year: "Technical Support Engineer| Full-Time ",
    title: "MontyMobile",
    desc: "● Build multiple projects from scratch to assist the message operations department using several language skills such as React JS, Laravel, Node JS And .Net. ● Assist a sales team with any technical questions",
    rate: "Dec 2022 – present",
  },
  {
    id: 5,
    category: "experience",
    year: "Full-Stack Developer | Full-Time Internship ",
    title: "Codi-Tech Boot Camp",
    desc: "● Arranged, tracked, and managed projects and daily tasks on Trello following Scrum methodology. ●  Developed e-commerce and Financial Tracker system using ReactJS, MongoDB, Node.js, PHP, and Laravel",
    rate: "May 2021 – Dec 2021",
  },
  {
    id: 6,
    category: "experience",
    year: "Network Engineer | Full-Time Internship ",
    title: "Ogero Telecom",
    desc: "● Designed a fiber network using Autocad ● Calculated the optical link budget ● Learned about FTTH, FTTC, and FTTW Topologies",
    rate: "Apr 2021 – May 2021 ",
  },
]

export default ResumeApi
